import React from 'react';
import { Box, Grid, Typography, styled } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
import { Card } from '@totalsoft/rocket-ui';

const EmptyQuotationsCard = styled(Card)(({ theme }) => ({
  '& .MuiCardHeader-root': {
    padding: 0
  },
  '& .MuiCardHeader-avatar': {
    marginLeft: theme.spacing(2)
  }
}));

const EmptyQuotationsListComponent = () => {
  const { t } = useTranslation();
  return (
    <Grid item xs={12}>
      <EmptyQuotationsCard icon={WarningIcon} disablePadding>
        <Box py={2}>
          <Typography variant='subtitle2' align='center' fontWeight='bold' color='primary'>
            {t('Offer.Edit.Casco.EmptyList')}
          </Typography>
        </Box>
      </EmptyQuotationsCard>
    </Grid>
  );
};

export default EmptyQuotationsListComponent;
